import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function Bankbook({ color }) {
  const theme = useContext(ThemeContext);
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.94922 5C3.84465 5 2.94922 5.89543 2.94922 7V7.33234C3.26569 7.12233 3.64539 7 4.05366 7H17.9484C18.3574 7 18.7377 7.12276 19.0545 7.33344V7C19.0545 5.89543 18.159 5 17.0545 5H4.94922Z'
        fill={color ? theme.palette[color] : theme.dim['60_white']}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.5 21C20.433 21 22 19.433 22 17.5C22 15.567 20.433 14 18.5 14C16.567 14 15 15.567 15 17.5C15 19.433 16.567 21 18.5 21ZM18.8348 20.5H18.2991V19.8084C17.8304 19.7648 17.3348 19.553 17 19.2726L17.3482 18.7804C17.6897 19.0421 18.058 19.229 18.4799 19.229C19.0022 19.229 19.2567 18.986 19.2567 18.581C19.2567 18.1114 18.8088 17.898 18.3298 17.6699C17.7792 17.4076 17.1875 17.1258 17.1875 16.4128C17.1875 15.7648 17.6228 15.31 18.2991 15.204V14.5H18.8348V15.1978C19.317 15.2539 19.6384 15.4657 19.9129 15.7399L19.5179 16.1573C19.2366 15.9143 19.0089 15.7773 18.6272 15.7773C18.1987 15.7773 17.9308 16.0016 17.9308 16.3816C17.9308 16.7835 18.3347 16.9665 18.7857 17.1708C19.3553 17.4288 20 17.7209 20 18.5312C20 19.1978 19.5714 19.6713 18.8348 19.7897V20.5Z'
        fill={color ? theme.palette[color] : theme.dim['60_white']}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 8C2.89543 8 2 8.89543 2 10V16C2 17.1046 2.89543 18 4 18H14.0275C14.0093 17.8358 14 17.669 14 17.5C14 15.0147 16.0147 13 18.5 13C19.026 13 19.5308 13.0902 20 13.2561V10C20 8.89543 19.1046 8 18 8H4Z'
        fill={color ? theme.palette[color] : theme.dim['60_white']}
      />
    </svg>
  );
}
